import { Flex, Image, Link, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import useExtension from 'src/hooks/useExtension'

export function Steps() {
  const { extensionUrl } = useExtension()
  const [t] = useTranslation()

  return (
    <Flex bg='backgroundColors.50' w='100%' flexDirection='column' alignItems='center'>
      <Text fontFamily='Poppins' fontSize='28px' fontWeight='bold' marginTop='32px' marginBottom='20px'>
        {t('onboard.success.desktop.secondSection.title')}
      </Text>
      <Flex flexDir='column'>
        <Image src='/assets/images/ext-steps-img.png' marginBottom='24px' w='100%' />
        <Flex gap='32px' align='center' justify='space-between'>
          <Text maxWidth='275px' textAlign='center' fontSize='0.875rem' color='bluishGray.400'>
            {t('clickInTheButton')} <strong>{t('addToChrome')}</strong> {t('locatedInThisPageOrVisite')}{' '}
            <Link
              href={extensionUrl}
              rel='noreferrer noopener nofollow'
              target='_blank'
              textDecoration='underline'
            >
              <strong>Chrome Web Store</strong>
            </Link>
          </Text>
          <Text maxWidth='275px' textAlign='center' fontSize='0.875rem' color='bluishGray.400'>
            {t('inTheExtensionPageClickIn')} <strong>{t('addToChrome')}</strong>
          </Text>
          <Text maxWidth='275px' textAlign='center' fontSize='0.875rem' color='bluishGray.400'>
            {t('clickInAddExtensionInPopUpTheInstalationIsAutomatic')}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}
